__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@amzn/awsscm-landing-page";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@amzn/awsscmui-argo-chatbot-component", "0.1.0", () => (Promise.all([__webpack_require__.e(25), __webpack_require__.e(914), __webpack_require__.e(672), __webpack_require__.e(740)]).then(() => (() => (__webpack_require__(53025))))));
			register("@amzn/awsui-collection-hooks", "1.0.0", () => (Promise.all([__webpack_require__.e(483), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(47483))))));
			register("lodash", "4.17.21", () => (__webpack_require__.e(536).then(() => (() => (__webpack_require__(53536))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(950), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(97950))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(981), __webpack_require__.e(914), __webpack_require__.e(423)]).then(() => (() => (__webpack_require__(23981))))));
			register("react", "18.3.1", () => (__webpack_require__.e(43).then(() => (() => (__webpack_require__(65043))))));
			register("uuid", "3.4.0", () => (__webpack_require__.e(924).then(() => (() => (__webpack_require__(95924))))));
			register("uuid", "3.4.0", () => (__webpack_require__.e(545).then(() => (() => (__webpack_require__(36545))))));
			register("uuid", "3.4.0", () => (__webpack_require__.e(736).then(() => (() => (__webpack_require__(38736))))));
			register("uuid", "3.4.0", () => (__webpack_require__.e(609).then(() => (() => (__webpack_require__(17609))))));
			register("uuid", "3.4.0", () => (__webpack_require__.e(509).then(() => (() => (__webpack_require__(56509))))));
			register("uuid", "3.4.0", () => (__webpack_require__.e(822).then(() => (() => (__webpack_require__(17441))))));
			register("uuid", "3.4.0", () => (__webpack_require__.e(249).then(() => (() => (__webpack_require__(50249))))));
			register("uuid", "8.3.2", () => (__webpack_require__.e(221).then(() => (() => (__webpack_require__(83221))))));
			register("uuid", "9.0.1", () => (__webpack_require__.e(425).then(() => (() => (__webpack_require__(80425))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};